<div class="container">
    <h1>Terms of Use</h1>

    <h3>Introduction</h3>

    <p>
        By signing up for NitroPay Sponsor’s recurring billing service ("Service") or any of the services of NitroPay
        Sponsor ("NitroPay Sponsor") you are agreeing to be bound by the following terms ("Terms of Service"). Any new
        products, features, or tools which are added to the current Service shall also be subject to the Terms of
        Service. You can review the current version of the Terms of Service at any time here. NitroPay and GG Software
        reserve the right to update and change the Terms of Service by posting updates and changes to the NitroPay
        Sponsor website. You are advised to check the Terms of Service from time to time for any updates or changes that
        may impact you.
    </p>

    <p>
        You must read, agree with and accept all of the terms contained in this Terms of Service agreement and
        NitroPay's Privacy Policy before utilizing NitroPay Sponsor in any way.
    </p>

    <p>By using NitroPay Sponsor, you are agreeing to these terms. Be sure to occasionally check back for updates.</p>

    <h3>Terms of Service</h3>

    <ol>
        <li>
            To use NitroPay Sponsor, you must be 18 years or older, or 13 years with parental consent. To access and use
            the services, you must register for a NitroPay Sponsor account (“Account”) or have an account with a
            NitroPay Sponsor partner (“Partner”), using information that has been indicated as required This may include
            full name, email address, or other personal information.
        </li>

        <li>
            NitroPay Sponsor may reject your application for an Account, or cancel an existing Account, for any reason,
            in our sole discretion.
        </li>

        <li>
            You acknowledge that NitroPay Sponsor utilizes third party services (Braintree Payments, Trolley, Tipalti,
            etc.) to complete business transactions and these services may require acceptance of additional terms and
            privacy policies. NitroPay and GG Software are not responsible for any damages or breach of service caused
            by these companies.
        </li>

        <li>
            You acknowledge that NitroPay will use the email address you provide as the primary method for
            communication.
        </li>

        <li>
            If applicable, you are responsible for keeping your NitroPay password secure, which is your means of
            entering the NitroPay portal. GG Software and NitroPay cannot and will not be liable for any loss or damage
            from your failure to maintain the security of your account and password.
        </li>

        <li>
            You are responsible for all activity and content such as photos, images, videos, graphics, written content,
            audio files, code, information, or data uploaded, collected, generated, stored, displayed, distributed,
            transmitted or exhibited on or in connection with your account (“Materials”).
        </li>

        <li>
            A breach or violation of any term in the Terms of Service as determined in the sole discretion of NitroPay
            will result in an immediate termination of your services.
        </li>
    </ol>

    <h3>Changes to the Agreements</h3>
    <ol>
        <li>
            Occasionally we may make changes to the Agreements. When we make material changes to the Agreements, we’ll
            provide you with notice as appropriate under the circumstances, e.g., by displaying a prominent notice
            within the Service or by sending you an email.
        </li>

        <li>
            In some cases, we will notify you in advance, and your continued use of the Service after the changes have
            been made will constitute your acceptance of the changes. Please therefore make sure you read any such
            notice carefully. If you do not wish to continue using the Service under the new version of the Agreements,
            you may terminate your account.
        </li>
    </ol>

    <h3>Partner Payments, Fees, and Schedule</h3>
    <ol>
        <li>
            As a Partner, you are creating a Paid Subscription service, with applicable membership tiers, on NitroPay
            Sponsor and providing this to your users. NitroPay Sponsor collects any appropriate payments and handles any
            chargebacks or cancellations.
        </li>

        <li>Value of each applicable NitroPay Sponsor membership tier is in the sole discretion of the Partner.</li>

        <li>
            Any fees will be subtracted from the selected membership fee prior to Partner payments. A processing fee of
            2.9% plus 30 cents per successful subscription for subscriptions over $3, and 5% plus 10 cents per
            successful subscription for subscriptions of $3 or less will be applied to the initial payment. PayPal
            payments from non-US subscribers have an additional 1% fee. After all processing fees are applied NitroPay
            Sponsor will then receive 5% of the collected revenue as a revenue share.
        </li>

        <li>
            NitroPay Sponsor reserves the right to determine if a Partner is acting in a way that could do any harm to
            the NitroPay Sponsor service, NitroPay, or GG Software and cancel or refund any payments.
        </li>

        <li>
            Payments to Partners are on a net-30 payment schedule. If any chargebacks force an account balance into the
            negative, NitroPay Sponsor reserves the right to recover funds from future payments.
        </li>
    </ol>
    <h3>Taxation</h3>
    <ol>
        <li>
            NitroPay Sponsor will handle tax withholding and reporting tax identification information to tax authorities
            as required. NitroPay will report and pay local, state, federal and any other taxes due.
        </li>
    </ol>

    <h3>User Subscriptions, Renewals and Cancellations</h3>
    <ol>
        <li>
            As a NitroPay Sponsor and Partner user, you may purchase a Paid Subscription by paying a subscription fee in
            advance on a monthly basis or some other recurring interval disclosed to you prior to your purchase.
        </li>

        <li>All transactions on NitroPay Sponsor are final and we do not process refunds.</li>

        <li>
            NitroPay Sponsor and Partners may change the price for the Paid Subscriptions, including recurring
            subscription fees, from time to time and will communicate any price changes to you in advance and, if
            applicable, how to accept those changes. Price changes will take effect at the start of the next
            subscription period following the date of the price change.
        </li>

        <li>
            Subject to applicable law, you accept the new price by continuing to use the NitroPay Sponsor and Partner
            service after the price change takes effect. If you do not agree with a price change, you have the right to
            reject the change by unsubscribing from the Paid Subscription prior to the price change going into effect.
        </li>

        <li>
            Your payment to NitroPay Sponsor Paid Subscription will automatically renew at the end of the applicable
            subscription period, unless you cancel your Paid Subscription before the end of the then-current
            subscription period. The cancellation will take effect the day after the last day of the current
            subscription period, and you will be downgraded. We do not provide refunds or credits for any partial
            subscription periods.
        </li>
    </ol>
    <h3>Using the NitroPay Sponsor Service</h3>
    <ol>
        <li>
            NitroPay Sponsor and its content are the property of GG Software. We grant you limited, non-exclusive,
            revocable permission to make use of NitroPay Sponsor (collectively, “Access”). This Access shall remain in
            effect until and unless terminated by you or NitroPay Sponsor. You promise and agree that you will not
            redistribute or transfer NitroPay Sponsor service or content.
        </li>

        <li>
            NitroPay Sponsor software applications and content are not sold or transferred to you, and NitroPay Sponsor
            retains ownership of the service.
        </li>

        <li>
            All NitroPay trademarks, service marks, trade names, logos, domain names, and any other features of the
            NitroPay brand (“NitroPay Brand Features”) are the sole property of NitroPay or its licensors. The
            Agreements do not grant you any rights to use any NitroPay Brand Features whether for commercial or
            non-commercial use.
        </li>

        <li>
            You agree to abide by our Terms of Service and not to use NitroPay Sponsor, or any part thereof in any
            manner not expressly permitted by the Agreements. Except for the rights expressly granted to you in the
            Agreements, NitroPay grants no right, title, or interest to you in NitroPay Sponsor.
        </li>

        <li>
            Third party software (for example, open source software libraries) included in the NitroPay Sponsor are made
            available to you under the relevant third party software library’s license terms as published in the help or
            settings section of our desktop and mobile client and/or on our website.
        </li>
    </ol>
    <h3>Third Party Applications and Devices</h3>
    <ol>
        <li>
            NitroPay Sponsor is integrated with or may otherwise interact with third party applications, websites, and
            services (“Third Party Applications”) and third party Devices to make NitroPay Sponsor available to you.
            These Third Party Applications and Devices may have their own terms and conditions of use and privacy
            policies and your use of these Third Party Applications and Devices will be governed by and subject to such
            terms and conditions and privacy policies.
        </li>

        <li>
            You understand and agree that NitroPay does not endorse and is not responsible or liable for the behavior,
            features, or content of any Third Party Application or Device or for any transaction you may enter into with
            the provider of any such Third Party Applications and Devices, nor does NitroPay warrant the compatibility
            or continuing compatibility of the Third Party Applications and Devices with the Service.
        </li>
    </ol>
    <h3>Limitation of liability</h3>
    <ol>
        <li>
            You expressly understand and agree that NitroPay Sponsor shall not be liable for any direct, indirect,
            incidental, special, consequential or exemplary damages, including but not limited to, damages for loss of
            profits, goodwill, use, data or other intangible losses resulting from the use of or inability to use the
            service.
        </li>

        <li>
            In no event shall NitroPay Sponsor be liable for lost profits or any special, incidental or consequential
            damages arising out of or in connection with our site, our services or this agreement (however arising
            including negligence). You agree to indemnify and hold us and (as applicable) our parent, subsidiaries,
            affiliates, NitroPay Sponsor partners, officers, directors, agents, and employees, harmless from any claim
            or demand, including reasonable attorneys fees, made by any third party due to or arising out of your breach
            of this Agreement or the documents it incorporates by reference, or your violation of any law or the rights
            of a third party.
        </li>

        <li>
            Your use of the Service is at your sole risk. The Service is provided on an as is and as available basis
            without any warranty or condition, express, implied or statutory.
        </li>

        <li>
            NitroPay Sponsor does not warrant that the Service will be uninterrupted, timely, secure, or error-free.
        </li>

        <li>
            NitroPay Sponsor does not warrant that the results that may be obtained from the use of the Service will be
            accurate or reliable.
        </li>

        <li>
            NitroPay Sponsor does not warrant that the quality of any products, services, information, or other material
            purchased or obtained by you through the Service will meet your expectations, or that any errors in the
            Service will be corrected.
        </li>
    </ol>

    <h3>Waiver and complete agreement</h3>
    <ol>
        <li>
            The failure of NitroPay Sponsor to exercise or enforce any right or provision of the Terms of Service shall
            not constitute a waiver of such right or provision.
        </li>

        <li>
            The Terms of Service constitutes the entire agreement between you and NitroPay Sponsor and govern your use
            of the Service, superseding any prior agreements between you and NitroPay Sponsor (including, but not
            limited to, any prior versions of the Terms of Service).
        </li>
    </ol>
</div>
